import { FC, useCallback } from 'react';
import { batch } from 'react-redux';

import { useMapContext } from 'shared/context/MapContext';
import { boundActionsFactory } from 'shared/store/clientSide';
import { useMapControlsIsCurrentAreaSearchActiveSelector } from 'shared/store/clientSide/slices/mapControls';
import { MapSelectedBounds } from 'shared/store/clientSide/slices/mapControls/slice';

import { CurrentAreaSearch } from './CurrentAreaSearch';
import { trackCurrentAreaSearch } from './internal/tracking';

const useBoundActions = boundActionsFactory(reduxActions => ({
  setIsCurrentAreaSearchActive: reduxActions.mapControls.setIsCurrentAreaSearchActive,
  setSelectedBounds: reduxActions.mapControls.setSelectedBounds,
}));

export const CurrentAreaSearchContainer: FC = () => {
  const boundActions = useBoundActions();
  const { map } = useMapContext();

  const handleClick = useCallback(() => {
    // Меняем местами яндексовские координаты, так как на бэке они перепутаны
    const mapBounds = map.getBounds().map(coords => {
      const [lat, lng] = coords;

      return [lng, lat];
    }) as MapSelectedBounds;

    batch(() => {
      boundActions.setIsCurrentAreaSearchActive(false);
      boundActions.setSelectedBounds(mapBounds);
    });

    trackCurrentAreaSearch();
  }, [boundActions, map]);

  const isVisible = useMapControlsIsCurrentAreaSearchActiveSelector();

  if (!isVisible) {
    return null;
  }

  return <CurrentAreaSearch handleClick={handleClick} />;
};
